<template>
    <div class="panel">
        <div class="panel-body">

            <el-row class="bottom20">
                <el-table :data="assessmentVersionTable.tableData" highlight-current-row>
                    <el-table-column prop="version" label="版本号">
                        <template slot="header" slot-scope="scope">
                            版本号<br>
                            <el-input size="mini" class="width70"
                                      v-model="searchParams.version"></el-input>
                        </template>
                        <template slot-scope="scope">
                            <el-button @click="queryDetail(scope.row.id)" type="text" size="mini">
                                {{scope.row.version}}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="reviseby" label="修订人员">
                        <template slot="header" slot-scope="scope">
                            修订人员<br>
                            <el-input size="mini" class="width70"
                                      v-model="searchParams.reviseby"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="revisedate" label="修订时间">
                        <template slot="header" slot-scope="scope">
                            修订时间<br><br><br>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot="header" slot-scope="scope">
                            状态<br>
                            <el-select class="width70" v-model="searchParams.status" clearable filterable
                                       placeholder="请选择状态" size="small">
                                <el-option
                                        v-for="item in assessmentVersionStatus"
                                        :key="item.value"
                                        :label="item.desc"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.status | statusFilter}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>

            <el-row type="flex" class="row-bg" justify="end">
                <el-pagination align="right" @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="currentPage"
                               :page-sizes="pageSizes" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="assessmentVersionTable.total">
                </el-pagination>
            </el-row>

        </div>
    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    import {debounce} from "../../../util/common";
    import assessmentVersionStatus from "../mixins/assessmentVersionStatus";

    const assessmentVersionNSHelper = createNamespacedHelpers("assessment/assessmentVersion");

    const assessmentConfigNSHelper = createNamespacedHelpers("assessment/assessmentConf");

    let that;

    export default {
        name: "assessmentVersionTable",

        mixins: [assessmentVersionStatus],

        data() {
            return {

                searchParams: {},

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],


            }
        },

        methods: {

            ...assessmentVersionNSHelper.mapActions(['getAssessmentVersionTable', 'getAssessmentVersionDetail']),
            ...assessmentConfigNSHelper.mapMutations(['setErrorIds']),

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }
                let params = {
                    ...this.searchParams, ...pageParams
                };
                this.getAssessmentVersionTable(params);
            },

            queryDetail(id) {
                this.getAssessmentVersionDetail(id);

                this.setErrorIds([]);

                this.$emit("showDetailTab");
            },

            transfer2StatusDesc(statusList, value) {
                let desc = '';
                statusList.forEach(e => {
                    if (e.value == value) {
                        desc = e.desc;
                        return;
                    }
                })
                return desc;
            },

        },

        computed: {

            ...assessmentVersionNSHelper.mapGetters(['assessmentVersionTable']),

        },

        watch: {

            searchParams: {
                deep: true,
                immediate: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.assessmentVersionTable.total = 0;
                    this.assessmentVersionTable.tableData = [];
                    this.queryTable();
                }, 500)
            },

        },

        filters: {

            statusFilter(value) {
                return that.transfer2StatusDesc(that.assessmentVersionStatus, value) || '';
            },


        },

        created() {
            that = this;
        }

    }
</script>

<style scoped>

</style>